export default () => {
  // Remove is-invalid class whenever input changes
  $('#InhouseContactForm input').on('change paste keyup', function () {
    $(this).removeClass('is-invalid');
  });
};
